import React, { useEffect } from 'react';
import { observer } from "mobx-react";
import 'react-toastify/dist/ReactToastify.css';
import { Layout } from '../components/Layout';
import store from '../components/Stores/SurveyStore';
import PrivateRoute from '../Routing/PrivateRoute'
import { Route } from 'react-router';
import PreviousYearDataPanel from '../components/PreviousYearDataPanel';
import SubsectionPanel from '../components/SubsectionPanel'

// Modals
import HelpModal from "../components/Modals/HelpModal"
import AddCommentModal from "../components/Modals/AddCommentModal"
import AddExplanationModal from "../components/Modals/AddExplanationModal"

// Misc
import DeveloperWindow from "../components/DeveloperWindow"
import { Switch} from 'react-router-dom';
import { LoadPABSSurvey } from '../control';
import { ToastContainer, Slide } from 'react-toastify';
import SurveyLoadingScreen from '../components/SurveyLoadingScreen'
import LogoutConfirmModal from '../components/Modals/LogoutConfirmModal';

// Tabs
import { PabsHomeTab } from './PabsSurvey.HomeTab'
import { PabsStartTab } from './PabsSurvey.StartTab'
import { PabsMembersTab } from './PabsSurvey.MembersTab'
import { PabsCostsTab } from './PabsSurvey.CostsTab'
import { PabsTransactionsTab } from './PabsSurvey.TransactionsTab'
import { PabsCommunicationTab } from './PabsSurvey.CommunicationTab'
import { PabsPlanDesignTab } from './PabsSurvey.PlanDesignTab'
import { PabsCustomerExperienceTab } from './PabsSurvey.CustomerExperienceTab'
import { PabsVocTab } from './PabsSurvey.VocTab'
import { PabsSubmitTab } from "./PabsSurvey.SubmitTab";
import PabsLaundromatPage from '../components/Laundromat/PabsLaundromatPage'

export const PabsSurvey = observer(() => {
    useEffect(() => {
        if (store.currentSurvey == null || store.currentSurvey[0] == null) {
            LoadPABSSurvey();
        }
    }, []);

    if (store.loadingSurvey) {
        return (<SurveyLoadingScreen />);
    }
    
    return (
        <Layout>
            <Switch>
                <PrivateRoute exact path='/pabs' component={PabsHomeTab} allowIfPageExists="Home" />
                <PrivateRoute exact path='/pabs/Home' component={PabsHomeTab} allowIfPageExists="Home" />
                <PrivateRoute exact path='/pabs/Start' component={PabsStartTab} allowIfPageExists={store.local.start} />
                <PrivateRoute exact path='/pabs/Members' component={PabsMembersTab} allowIfPageExists={store.local.members} />
                <PrivateRoute exact path='/pabs/Costs' component={PabsCostsTab} allowIfPageExists={store.local.costs} />
                <PrivateRoute exact path='/pabs/Transactions' component={PabsTransactionsTab} allowIfPageExists={store.local.transactions} />
                <PrivateRoute exact path='/pabs/Communication' component={PabsCommunicationTab} allowIfPageExists={store.local.communication} />
                <PrivateRoute exact path='/pabs/CustomerExperience' component={PabsCustomerExperienceTab} allowIfPageExists={store.local.customerExperience} />
                <PrivateRoute exact path='/pabs/PlanDesign' component={PabsPlanDesignTab} allowIfPageExists={store.local.planDesign} />
                <PrivateRoute exact path='/pabs/VoC' component={PabsVocTab} allowIfPageExists={store.local.voc} />
                <PrivateRoute exact path='/pabs/Submit' component={PabsSubmitTab} allowIfPageExists="Home" />
                <PrivateRoute exact path='/pabs/laundromat' component={PabsLaundromatPage} />

                <Route path="*" component={PabsHomeTab} />
            </Switch>
            { store.isAvailableSurveysEmpty && <div style={{textAlign: 'center', paddingTop: '450px'}}><h1>No surveys available</h1></div> }
            <SubsectionPanel />
            <PreviousYearDataPanel />
            <HelpModal />
            <AddCommentModal />
            <AddExplanationModal />
            <LogoutConfirmModal />
            <DeveloperWindow />
            <ToastContainer transition={Slide} />
        </Layout>
    );
});




